import { useState, useEffect } from "react";
import "./universityCommunity.scss";
import TabsSet from "componets/molecules/comunityTabs/tabsSet";
import SemiCircleCard from "componets/molecules/circleCard/semiCircleCard";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
//
const UniversityComunity = ({ data }) => {
  const [selected, setSelected] = useState("estudiantes");
  const [actualData, setActualData] = useState(data.estudiantes);
  useEffect(() => {
    switch (selected) {
      case "estudiantes":
        setActualData(data.estudiantes);
        break;
      case "docentes":
        setActualData(data.docentes);
        break;
      case "administrativos":
        setActualData(data.administrativos);
        break;
      case "egresados":
        setActualData(data.egresados);
        break;
      default:
        break;
    }
  }, [selected]);
  const tabsData = {
    groupName: "comunitySelection",
    tabs: [
      { value: "estudiantes", text: "Estudiantes" },
      { value: "docentes", text: "Docentes" },
      { value: "egresados", text: "Egresados" },
      { value: "administrativos", text: "Administrativos" },
    ],
  };

  /*const data = 
            [{title: "DNINFOA SIA", description:"Acceda a los servicios del DNINFOA - SIA para introducir calificaciones, gestionar asignaturas, etc."},
            {title: "DNINFOA SIA", description:"Don doña doña SIA utilizada por todo el mundo y a nadie le gusta"},
            {title: "Bienestar", description:"Don doña doña SIA utilizada por todo el mundo y a nadie le gusta"},
            {title: "Administrativo", description:"Don doña doña SIA utilizada por todo el mundo y a nadie le gusta"}
            ]*/
  const description =
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. ";
  return (
    <div className="university-com__container">
      <TabsSet
        tabsData={tabsData}
        setSelected={setSelected}
        textSize={3}
      ></TabsSet>
      {actualData !== undefined && (
        <>
          <ReactMarkdown className="university_com__description">
            {actualData.DescripcionInicial}
          </ReactMarkdown>
          {(actualData.cartas !== undefined ||
            actualData.cartas.length >= 0) && (
            <>
              {actualData.cartas.map(
                (carta, index) =>
                  index < 4 && (
                    <SemiCircleCard
                      key={index}
                      className="university_com__card"
                      data={carta}
                      textSize={1}
                    />
                  )
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default UniversityComunity;
